export default ({ request }) => ({
  /**
     * 获取简历明细
     * @param params
     * @returns {*}
     * @constructor
     */
  RESUME_API_DETAIL(params) {
    // 接口请求
    return request({
      url: `/resume`,
      method: 'GET',
      params
    })
  },
  /**
   * 创建工作经历
   * @param data
   * @returns {*}
   * @constructor
   */
   RESUME_API_WORK(data) {
    // 接口请求
    return request({
      url: `/resume/workhistory`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取工作经历
   * @param params
   * @returns {*}
   * @constructor
   */
   RESUME_API_WORK_DETAIL(params) {
    // 接口请求
    return request({
      url: `/resume/workhistory`,
      method: 'GET',
      params
    })
  },
  /**
   * 删除工作经历
   * @param data
   * @returns {*}
   * @constructor
   */
   RESUME_API_WORK_DELETE(data) {
    // 接口请求
    return request({
      url: `/resume/workhistory/delete`,
      method: 'POST',
      data
    })
  },

})

